import React, { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { createBrowserHistory } from "history"
import { CircularProgress } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { index } from './store/actions/app.action'

const Auth = lazy(() => import('./view/auth'))
const Pixel = lazy(() => import('./view/mobile/pixel'))
const Utms = lazy(() => import('./view/mobile/utms'))
const Google = lazy(() => import('./view/mobile/google'))
const Webhooks = lazy(() => import('./view/mobile/webhooks'))
const Campaigns = lazy(() => import('./view/mobile/campaigns'))
const Closed = lazy(() => import('./view/mobile/campaigns/closed'))
const Password = lazy(() => import('./view/mobile/password'))

const RoutesMobile = () => {
    const history = createBrowserHistory()
    const [loading, setLoading] = React.useState(true)
    const dispatch = useDispatch() 

    React.useEffect(() => {
        if(history.location.pathname !== '/login') {
            dispatch(index()).then(res => res && setLoading(false))
        }else {
            setLoading(false)
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    return (
        <>
        {(history.location.pathname !== '/login' && loading ) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
        <Router>
            <Suspense fallback={<div className="d-flex justify-content-center align-items-center min-vh-100"> <CircularProgress/> </div>}>
                <Switch>
                    <Route exact path="/pixel" component={Pixel} />
                    <Route exact path="/utms" component={Utms} />
                    <Route exact path="/google-tag-manager" component={Google} />
                    <Route exact path="/password" component={Password} />
                    <Route exact path="/webhooks" component={Webhooks} />
                    <Route exact path="/campaigns" component={Campaigns} />
                    <Route exact path="/campaigns/closed" component={Closed} />
                    <Route exact path="/login" component={Auth} />
                    <Route exact path="/" component={Campaigns} />
                </Switch>
            </Suspense>
        </Router>
        }
        </>
    )
}

export default RoutesMobile;